<template>
  <div class="order-purchase-number">
    <v-radio-group
      v-model="localValue.delivery.method.method"
    >
      <v-row
        v-for="(option, i) in deliveryOptions"
        :key="i"
      >
        <v-col cols="4">
          <v-radio
            :value="option"
            :label="option.text"
          />
        </v-col>
        <v-col v-if="option.businessDays">
          <span>
            {{ option.businessDays }} business days
          </span>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import ModelableMixin from '../../../../mixins/modelable';

export default {
  name: 'Method',

  mixins: [
    ModelableMixin,
  ],

  computed: {
    deliveryOptions() {
      return [
        { text: 'Standard', businessDays: 20 },
        { text: 'Express', businessDays: 12 },
        { text: 'Priority', businessDays: 7 },
        { text: 'Absolute', businessDays: 3 },
        { text: 'Pick another date' },
      ];
    },
  },
};
</script>

<style scoped>

</style>
